import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import content, { contentPropTypes } from './PaymentDetails.content';
import withContent from '../../../containers/withContent';

export default (WrappedComponent) => {
	const withPaymentDetailsContainer = (props) => <WrappedComponent {...props} content={props.content} />;
	withPaymentDetailsContainer.propTypes = {
		content: PropTypes.shape(contentPropTypes),
	};
	withPaymentDetailsContainer.displayName = `withPaymentDetailsContainer(${
		WrappedComponent.displayName || WrappedComponent.name || 'Component'
	})`;
	return compose(withContent({ content }))(withPaymentDetailsContainer);
};
